
/**
 * ---------------------------
 * The Fireable class
 * ---------------------------
 */

export default class {
	
	/**
	 * Sets a "disconnected" flag on the Fireable.
	 *
	 * @return void
	 */
	disconnect() {
		this.disconnected = true;
	}
};